export enum TimeTrackerDropdownLayoutType {
  Legacy = 'legacy',
  Modern = 'modern',
}
